export default function isEmail(email: string) {
  const emailRegex = new RegExp(/^[\.+\w-]+@[\.a-zA-Z0-9_\-]+?\.[a-zA-Z]{2,3}$/);
  return emailRegex.test(email);
}
